import { Auth } from 'aws-amplify';
import observe from '../util/observe';
import '../configuration';

window.auth = Auth;

const Identity = {
	user: null,
	get username() {
		if (this.user) {
			return this.user.username;
		} else {
			return null;
		}
	},
	signIn: () => Auth.federatedSignIn(),
	signOut: () => {
		Auth.signOut().then(() => Identity.user = null)
	}
};

Auth.currentAuthenticatedUser()
	.then(user => Identity.user = user)
	.catch(() => Identity.user = null)
;

window.Identity = Identity;
window.Auth = Auth;

export default Identity;
